/* ADDED */

// When the Cart Drawer updates, update other producty qty selectors

const parentElement = document.querySelector('cart-drawer');

parentElement.addEventListener('click', function(event) {

//console.log(event.target.parentElement);

  if (event.target.parentElement.classList.contains('quantity')) {
    const inputElement = event.target.parentElement.querySelector('input');
    const productID = inputElement.getAttribute('data-product-id');
    const quantityValue = parseInt(inputElement.value);
    const maxQuantity = parseInt(inputElement.getAttribute('max'));

    console.log('Quantity changing to: ' + quantityValue + ' for Product ID: ' + productID);

    // disable this button to prevent hammering, renabled in cart.js
    const quantityButtons = document.querySelectorAll('.quantity__button');
    quantityButtons.forEach(button => {
      button.disabled = true;
      button.style.opacity = 0.25;
    });

    // Find any other inputs of the same product id and change its value
    const quantityInputs = document.querySelectorAll(`.quantity__input[data-product-id='${productID}']`);
    quantityInputs.forEach(function(quantityInput) {
        quantityInput.value = quantityValue;
        //console.log('Quantity changed to:', quantityValue);
    });

    if (quantityValue >= maxQuantity) {
      console.error('Max quantity reached for Product ID: ' + productID);
      console.log('Max quantity is: ' + maxQuantity);
      console.log('Current quantity is: ' + quantityValue);
      //console.log('quantityValue:', quantityValue, 'type:', typeof quantityValue);
      //console.log('maxQuantity:', maxQuantity, 'type:', typeof maxQuantity);

      // Keep the plus disabled so users dont keep trying
      quantityInputs.forEach(function(quantityInput) {
        quantityInput.parentElement.querySelector('button[name="plus"]').disabled = true;
        quantityInput.parentElement.querySelector('button[name="plus"]').style.opacity = 0.25;
        quantityInput.parentElement.querySelector('button[name="plus"]').setAttribute('limit-reached', 'true');
      });

      // wait 1 second and renable the buttons, as they wont otherwise
      setTimeout(() => {
        quantityButtons.forEach(button => {
          if (!button.hasAttribute('limit-reached')) {
            button.disabled = false;
            button.style.opacity = 1;
          }
        });
      }, 1000);

    } else {
      // remove the limit-reached attribute if it exists
      quantityInputs.forEach(function(quantityInput) {
        quantityInput.parentElement.querySelector('button[name="plus"]').removeAttribute('limit-reached');
      });
    }



    if (quantityValue == 0) { // If 0, act as if it was removed and reset the relevant buttons.
      
      /* DIRECT COPY FROM CartRemoveButton FUNCTION */

      // Find any boost product grid items of the same ID and reset.
      const boostProductItems = document.querySelectorAll(`.boost-pfs-filter-product-item[data-id='${productID}']`);
      boostProductItems.forEach(function(boostProductItem) { // Probably only every 1 shown, but lets just loop it
        boostProductItem.classList.remove("boost-pfs-added");
        boostProductItem.querySelector('.quantity__input').value = 1; // Reset incase user adds again
      });

      // Find any product page items of the same ID and reset.
      const productForm = document.querySelector(`.unero-single-product-detail product-form[data-id='${productID}']`);
      if (productForm) {
        const productQty = document.querySelector(`.unero-single-product-detail .product-form__input[data-id='${productID}']`);
        productForm.classList.remove("hide");
        productQty.classList.add("hide");
        productQty.querySelector('.quantity__input').value = 1; // Reset in case user adds again
      }

      const ppProductItems = document.querySelectorAll(`.pp-item[data-product-id='${productID}']`);
      
      ppProductItems.forEach((ppProductItem) => {
        ppProductItem.classList.remove("is--in-cart");
      
        const addToCartBtn = ppProductItem.querySelector('.pp-item__add-to-cart');
        addToCartBtn.classList.remove("hide");
        addToCartBtn.classList.add("removing");
        addToCartBtn.disabled = true;
        setTimeout(() => {
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove("removing");
        }, 3000);
      
        ppProductItem.querySelector('.pp-item__quantity').classList.add("hide");
        ppProductItem.querySelector('.quantity__input').value = 1; // Reset in case user adds again
        console.log(ppProductItem.querySelector('.quantity__input').value);
      });


    }

  }
});




// When a user clicks the QTY changer on product form, pass a click to the cart drawer element to handle the functionality.
// Ideal way to do this would be with section rendering, but out of scope at the moment.

const productForm = document.querySelector('.product-form__input quantity-input.non-cart');

if (productForm) {

  productForm.addEventListener('click', function(event) {


    if (event.target.parentElement.classList.contains('quantity')) {
      const inputElement = event.target.parentElement.querySelector('input');
      const qtyDirection = event.target.getAttribute('name');
      const productID = inputElement.getAttribute('data-product-id');

      const cartDrawerItem = document.querySelector(`cart-drawer .quantity__input[data-product-id='${productID}']`);
      const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`)

      if (!cartDrawerItemButton.disabled) {
        cartDrawerItemButton.click();

      // disable this button to prevent hammering, renabled in cart.js
       const quantityButtons = document.querySelectorAll('.quantity__button');
       quantityButtons.forEach(button => {
         button.disabled = true;
         button.style.opacity = 0.25;
       });

      } else {
        console.log('Button is disabled cannot send click to cart drawer');

        // set this button to be disabled to prevent more clicks
        event.target.disabled = true;
        event.target.style.opacity = 0.25;

      }
    
    }
  });

}

// Direct copy of above, but for pp page

const previouslyPurchasedGrid = document.querySelector('.pp__collections');

if (previouslyPurchasedGrid) {

  previouslyPurchasedGrid.addEventListener('click', function(event) {

    if (event.target.parentElement.classList.contains('quantity')) {

      const inputElement = event.target.parentElement.querySelector('input');
      const qtyDirection = event.target.getAttribute('name');
      const productID = inputElement.getAttribute('data-product-id');

      const cartDrawerItem = document.querySelector(`cart-drawer .quantity__input[data-product-id='${productID}']`);
      const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`)

      if (!cartDrawerItemButton.disabled) {
        cartDrawerItemButton.click();

      // disable this button to prevent hammering, renabled in cart.js
       const quantityButtons = document.querySelectorAll('.quantity__button');
       quantityButtons.forEach(button => {
         button.disabled = true;
         button.style.opacity = 0.25;
       });

      } else {
        console.log('Button is disabled cannot send click to cart drawer');

        // set this button to be disabled to prevent more clicks
        event.target.disabled = true;
        event.target.style.opacity = 0.25;

      }
    
    }
  });

}


// Direct copy of above, but for product boost grid 
const productGrid = document.querySelector('.boost-pfs-filter-products');

if (productGrid) {

  productGrid.addEventListener('click', function(event) {

    if (event.target.parentElement.classList.contains('quantity')) {

      const inputElement = event.target.parentElement.querySelector('input');
      const qtyDirection = event.target.getAttribute('name');
      const productID = inputElement.getAttribute('data-product-id');

      const cartDrawerItem = document.querySelector(`cart-drawer .quantity__input[data-product-id='${productID}']`);
      const cartDrawerItemButton = cartDrawerItem.parentElement.querySelector(`button[name='${qtyDirection}']`)

      if (!cartDrawerItemButton.disabled) {
        cartDrawerItemButton.click();

      // disable this button to prevent hammering, renabled in cart.js
       const quantityButtons = document.querySelectorAll('.quantity__button');
       quantityButtons.forEach(button => {
         button.disabled = true;
         button.style.opacity = 0.25;
       });

      } else {
        console.log('Button is disabled cannot send click to cart drawer');

        // set this button to be disabled to prevent more clicks
        event.target.disabled = true;
        event.target.style.opacity = 0.25;

      }
    
    }
  });

}



document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  const referrer = document.referrer;

  if (referrer.includes('/cart') && cartDrawer) {
      cartDrawer.open();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  if (window.location.href.indexOf("#cart") > -1) {
    console.log("Opening Cart");

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
    }
  }
});






/* ORIGINAL FROM DAWN */

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    //this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    document.body.classList.remove('modal-open');



  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      //this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble',
        selector: '.cart-content'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      } ,
      {
        id: 'icon-cart-contents',
        section: 'cart-icon-bubble',
        selector: '.cart-content'
      } 
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
